import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

import PlaybookReportLayout from 'layouts/PlaybookReportLayout'
import CampaignReportLayout from 'layouts/CampaignReportLayout'

import './style.css'
class AppLayout extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/reports/playbooks" component={PlaybookReportLayout} />
          <Route path="/reports/campaigns" component={CampaignReportLayout} />
        </Switch>
      </Router>
    )
  }
}

export default AppLayout
